"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AgentWait = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _constants = require("../../constants");

var _conversation = require("../../store/actions/conversation");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AgentWait =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AgentWait, _React$Component);

  function AgentWait(props) {
    var _this;

    _classCallCheck(this, AgentWait);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AgentWait).call(this, props));
    _this.leaveQueue = _this.leaveQueue.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AgentWait, [{
    key: "leaveQueue",
    value: function leaveQueue() {
      var props = this.props;
      props.conversationSend(_constants.SLASH_COMMAND_CHAT_LEAVE_QUEUE);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var formatMessage = props.intl.formatMessage;
      var seconds = props.items[0];
      var waitTime;

      if (seconds === null) {
        waitTime = formatMessage({
          id: 'Support:HelpBot:LiveEngage:WaitTimeUnknown'
        });
      } else if (seconds < 90) {
        waitTime = formatMessage({
          id: 'Support:HelpBot:LiveEngage:WaitTimeOneMinute'
        });
      } else {
        var minutes = Math.round(seconds / 60);
        waitTime = formatMessage({
          id: 'Support:HelpBot:LiveEngage:WaitTimeMinutes'
        }, {
          minutes: minutes
        });
      }

      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "jsx-2717819117" + " " + 'wait-time-container'
      }, _react["default"].createElement("div", {
        className: "jsx-2717819117" + " " + 'estimated-wait-time'
      }, _react["default"].createElement("div", {
        className: "jsx-2717819117"
      }, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Support:HelpBot:LiveEngage:InChatQueue"
      })), _react["default"].createElement("div", {
        className: "jsx-2717819117"
      }, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Support:HelpBot:LiveEngage:EstimatedWaitTime",
        values: {
          waitTime: waitTime
        }
      }))), _react["default"].createElement("div", {
        className: "jsx-2717819117" + " " + 'clock-dial'
      }, _react["default"].createElement("div", {
        className: "jsx-2717819117" + " " + 'minute-hand'
      }), _react["default"].createElement("div", {
        className: "jsx-2717819117" + " " + 'hour-hand'
      })), _react["default"].createElement("div", {
        onClick: this.leaveQueue,
        onKeyPress: function onKeyPress() {},
        role: "button",
        tabIndex: "0",
        className: "jsx-2717819117" + " " + 'leave-queue'
      }, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Support:HelpBot:LiveEngage:LeaveChatQueue"
      }))), _react["default"].createElement(_style["default"], {
        id: "2717819117"
      }, ".wait-time-container.jsx-2717819117{margin-bottom:20px;margin-top:24px;}.wait-time-container.jsx-2717819117 .finding-agent.jsx-2717819117,.wait-time-container.jsx-2717819117 .estimated-wait-time.jsx-2717819117{text-align:center;}.wait-time-container.jsx-2717819117 .finding-agent.jsx-2717819117{color:#757575;font-size:12px;}.wait-time-container.jsx-2717819117 .clock-dial.jsx-2717819117{height:74px;width:74px;margin:16px auto;position:relative;border-radius:50%;background-color:#d6d6d6;}.wait-time-container.jsx-2717819117 .clock-dial.jsx-2717819117 .minute-hand.jsx-2717819117,.wait-time-container.jsx-2717819117 .clock-dial.jsx-2717819117 .hour-hand.jsx-2717819117{background-color:#fff;border-radius:30px;position:absolute;width:5px;}.wait-time-container.jsx-2717819117 .clock-dial.jsx-2717819117 .minute-hand.jsx-2717819117{height:24px;-webkit-transform:translate(35px,18px);-ms-transform:translate(35px,18px);transform:translate(35px,18px);}.wait-time-container.jsx-2717819117 .clock-dial.jsx-2717819117 .hour-hand.jsx-2717819117{height:18px;-webkit-transform:translate(41px,35px) rotate(120deg);-ms-transform:translate(41px,35px) rotate(120deg);transform:translate(41px,35px) rotate(120deg);-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;}.wait-time-container.jsx-2717819117 .leave-queue.jsx-2717819117{color:#9e42b5;cursor:pointer;font-size:14px;margin:0 auto;outline:none;text-align:center;-webkit-text-decoration:underline !important;text-decoration:underline !important;width:230px;}"));
    }
  }]);

  return AgentWait;
}(_react["default"].Component);

exports.AgentWait = AgentWait;
AgentWait.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  conversationSend: _propTypes["default"].func.isRequired,
  intl: _reactIntl.intlShape
};
var mapDispatchToProps = {
  conversationSend: _conversation.conversationSend
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactIntl.injectIntl)(AgentWait));

exports["default"] = _default;